import React from 'react';
import LoadingButton from 'src/components/BulkOperations/_Shared/BulkActionButton/LoadingButton';
import FontAwesomeIcon from 'src/components/Icon';
import CopyButton from './CopyButton';
import './ActivationLinkField.scss';

interface ActivationLinkFieldProps {
  link: string;
  isRevealed: boolean;
  onCopy: () => void;
  actionLabel: string;
  isGenerating: boolean;
  onGenerate: () => void;
}

const ActivationLinkField = ({
  link,
  isRevealed,
  onCopy,
  actionLabel,
  isGenerating,
  onGenerate,
}: ActivationLinkFieldProps) => {
  const linkValueClass: string = isRevealed
    ? 'link-value revealed'
    : 'link-value';

  const copyButton: React.ReactNode = isRevealed ? (
    <CopyButton onCopy={onCopy} />
  ) : null;

  return (
    <div className="link-field">
      <FontAwesomeIcon glyph="link" weight="light" />
      <span className={linkValueClass}>{link}</span>
      {copyButton}
      <LoadingButton
        actionText={actionLabel}
        isSubmitting={isGenerating}
        disabled={false}
        onClick={onGenerate}
      />
    </div>
  );
};

export default ActivationLinkField;